import {create} from 'zustand'
import {persist, createJSONStorage} from 'zustand/middleware'

/**
 * @typedef {'climate-led'|'compact'|'ops-focused'} DashboardLayout
 */

export const useDashboardLayoutStore = create(
    persist(
        (set) => ({
            /** @type {DashboardLayout} */
            layout: 'climate-led',
            /** @param {DashboardLayout} layout */
            setLayout: (layout) => set({layout})
        }),
        {
            name: 'verdasync.dashboardLayout',
            storage: createJSONStorage(() => localStorage)
        }
    )
)

export const useInstallPromptStore = create((set) => ({
    /** @type {BeforeInstallPromptEvent|null} */
    event: null,
    /** @param {BeforeInstallPromptEvent|null} event */
    setEvent: (event) => set({event}),
    clear: () => set({event: null})
}))
